<script context="module">/**
 * This component renders a block's wrapper HTML element (from the block's `tagName` property).
 */
</script>

<script>import { getBlockActions } from "../../../functions/get-block-actions";
import { getBlockProperties } from "../../../functions/get-block-properties";
import DynamicRenderer from "../../dynamic-renderer/dynamic-renderer.svelte";
export let Wrapper;
export let block;
export let context;
</script>

<DynamicRenderer
  TagName={Wrapper}
  attributes={getBlockProperties({
    block: block,
    context: $context,
  })}
  actionAttributes={getBlockActions({
    block: block,
    rootState: $context.rootState,
    rootSetState: $context.rootSetState,
    localState: $context.localState,
    context: $context.context,
    stripPrefix: true,
  })}><slot /></DynamicRenderer
>